import React, { useState, useEffect } from "react";
import Footer from "../../Global/Footer";
import { Mainlandingmob } from "../../Mobilemain/Mainlandingmob";

import Billionaires from "./Billionaires";
import Carousels from "./Carousels";
import FAQ from "./FAQ";
import FAQs from "./FAQS";
import Future from "./Future";
import Mainbanner from "./Mainbanner";
import Mainbecome from "./Mainbecome";

import Roadmap from "./Roadmap";

import Team from "./Team";

export default function Mainlanding() {
  const [widthh, setWidth] = useState(window.innerWidth);
  const breakpoint = 720;

  useEffect(() => {
    window.addEventListener("resize", () => setWidth(window.innerWidth));
  }, []);
  return (
    <>
      {widthh <= breakpoint ? (
        <Mainlandingmob />
      ) : (
        <>
          <Mainbanner />
          <Billionaires />
          <Mainbecome />
          <Carousels />
          <FAQ />
          <Roadmap />
          <Team />
          <Future />

          <FAQs />
          <Footer />
        </>
      )}
    </>
  );
}
